class MenuAccordion {
  constructor(container) {
    this.container = container;
    this.init();
  }


  setupAccordion() {
    // Listener globale per gestire i click
    document.addEventListener("click", (event) => {
      // Verifica se il click è avvenuto su un'header di un accordion
      const header = event.target.closest("[data-accordion-header]");
      if (!header || !this.container.contains(header)) return;

      const item = header.closest("[data-accordion-item]");
      const isActive = item.classList.contains("is-active");

      // Chiude tutti gli accordion, anche se sono cloni
      this.closeAllItems();

      // Se l'elemento cliccato non è attivo, aprilo
      if (!isActive) {
        const icon = header.querySelector(".menu-accordion__icon");
        const content = item.querySelector("[data-accordion-content]");
        this.openItem(item, icon, content);
      }
    });
  }

  openItem(item, icon, content) {
    item.classList.add("is-active");
    content.classList.add("is-active");

    const header = item.querySelector("[data-accordion-header]");
    if (header) {
      header.classList.add("is-open");
      header.setAttribute("aria-expanded", "true");
    }
  }

  closeItem(item, icon, content) {
    item.classList.remove("is-active");
    content.classList.remove("is-active");

    const header = item.querySelector("[data-accordion-header]");
    if (header) {
      header.classList.remove("is-open");
      header.setAttribute("aria-expanded", "false");
    }
  }
  closeAllItems() {
    // Chiude tutti gli accordion presenti nel documento
    const allItems = document.querySelectorAll("[data-accordion-item]");
    allItems.forEach((item) => {
      if (item.classList.contains("is-active")) {
        const content = item.querySelector("[data-accordion-content]");
        const icon = item.querySelector(".menu-accordion__icon");
        this.closeItem(item, icon, content);
      }
    });
  }

  init() {
    this.setupAccordion();
  }
}

export default MenuAccordion;
